import { User } from './User';
import { Workspace } from './Workspace';

export enum ImportedCompanyVisibility {
    PRIVATE = 'Private',
    WORKSPACE = 'Workspace',
}

export enum ImportedCompanyEntityType {
    COMPANY = 'Company',
    FUND = 'Fund',
    ENTITY = 'Entity',
    OTHER = 'Other',
}

export enum ImportedCompanyProcessingStatus {
    READY = 'Ready',
    PROCESSING = 'Processing',
    FAILED = 'Failed',
}

export enum ImportedCompanySourceType {
    DATA_SOURCE = 'Data Source',
    GOOGLE_SHEETS = 'Google Sheets',
    MANUAL = 'Manual Entry',
    UPLOAD = 'Upload',
}

export type ImportedCompanyColumnMapping = {
    confidence: number;
    dataType: string;
    sourceColumn: string;
    targetField: string;
    targetLabel: string;
};

export type ImportedCompanyFinancialSectionData = {
    columnMappings?: ImportedCompanyColumnMapping[];
    rows?: Array<Record<string, unknown>>;
    sourceMetadata?: Record<string, unknown>;
};

export interface ImportedCompany {
    id: string;
    workspace: Workspace;
    user: User;
    name: string;
    entityType: ImportedCompanyEntityType;
    sourceType: ImportedCompanySourceType;
    processingStatus: ImportedCompanyProcessingStatus;
    website?: string;
    description?: string;
    dedupeKey?: string;
    importBatchId?: string;
    sourceRecordId?: string;
    columnMappings?: ImportedCompanyColumnMapping[];
    sourceMetadata?: Record<string, unknown>;
    enrichmentData?: Record<string, unknown>;
    initialData: Array<Record<string, unknown>>;
    capitalStructureData?: ImportedCompanyFinancialSectionData;
    holdingsData?: ImportedCompanyFinancialSectionData;
    balanceSheetData?: ImportedCompanyFinancialSectionData;
    incomeStatementData?: ImportedCompanyFinancialSectionData;
    cashFlowsStatementData?: ImportedCompanyFinancialSectionData;
    returnsData?: ImportedCompanyFinancialSectionData;
    multiplesData?: ImportedCompanyFinancialSectionData;
    deletedAt?: Date | null;
    deletedByUserId?: null | string;
    visibility: ImportedCompanyVisibility | undefined;
    createdAt: Date;
    updatedAt: Date;
}
